module.exports = __webpack_public_path__ + "img/img-1.8af16fa0.png";